/* eslint-disable max-len */
import React from 'react';

import { icons } from '../../../constants/icons';

export const DrugsIconSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622463315554"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5834"
  >
    <path
      d="M956.288 804.48L640 277.44V63.968h32c17.6 0 32-14.4 32-32s-14.4-32-32-32H352c-17.6 0-32 14.4-32 32s14.4 32 32 32h32V277.44L67.712 804.48C-4.736 925.216 51.2 1024 192 1024h640c140.8 0 196.736-98.784 124.288-219.52zM241.024 640L448 295.072V64h128v231.072L782.976 640H241.056z"
      p-id="5835"
    />
  </svg>
);

export const HomeIconSvg = ({ width = 26, height = 26 }) => (
  // <svg t="1622705375067" class="icon" viewBox="0 0 1186 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4025" width={width} height={height} ><path d="M592.979172 99.298087C764.545352 247.565155 1107.6777 544.099291 1107.6777 544.099291 1127.383121 561.128658 1157.162536 558.959296 1174.191903 539.253885 1191.221271 519.548473 1189.051915 489.76905 1169.346507 472.739683L644.064741 18.792487C615.090477-6.247004 570.577796-6.245391 541.605404 18.792487L16.323639 472.739683C-3.381769 489.76905-5.551125 519.548473 11.478242 539.253885 28.50761 558.959296 58.287024 561.128658 77.992446 544.099291 77.992446 544.099291 590.438069 97.102073 592.979172 99.298087L592.979172 99.298087ZM249.34468 1017.263247 451.27768 1017.263247C481.089363 1017.263247 505.25651 993.204509 505.25651 963.284413L505.25651 707.372587 680.4121 707.372587 680.4121 963.284413C680.4121 993.0961 704.63663 1017.263247 734.344069 1017.263247L949.844297 1017.263247C979.630098 1017.263247 1003.776266 993.112147 1003.776266 963.461138L1003.776266 545.711842C1003.776266 519.655814 982.610236 498.53323 956.618992 498.53323 930.574743 498.53323 909.461718 519.580059 909.461718 545.574717L909.461718 922.948698 774.726648 922.948698 774.726648 667.036873C774.726648 637.225185 750.648346 613.058039 720.758247 613.058039L464.910363 613.058039C435.104446 613.058039 410.941961 637.116776 410.941961 667.036873L410.941961 922.948698 289.680399 922.948698 289.680399 545.574717C289.680399 519.59442 268.514368 498.53323 242.523125 498.53323 216.478876 498.53323 195.36585 519.672553 195.36585 545.711842L195.36585 963.461138C195.36585 993.175222 219.424589 1017.263247 249.34468 1017.263247Z" p-id="4026"></path></svg>
  <svg
    width={ width }
    height={ height }
    t="1622464365217"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7476"
  >
    <path
      stroke="grey"
      strokeWidth="9"
      d="M486.573336 71.898935c7.123954-7.362546 17.077215-11.745257 25.673678-11.660265 8.794095-0.080896 17.764318 4.00588 25.122767 11.620329l397.710589 410.025189-75.809645 0.001024c-16.631776 0-30.115782 13.48503-30.115782 30.117829v403.290354c0 26.619852-16.199649 48.470946-33.612735 48.470946h-127.979271V684.68085c0-103.962422-18.016221-133.953276-108.782381-133.953276H465.212737c-90.778448 0-108.782381 29.977542-108.782381 133.953276v279.083491H228.452108c-17.425374 0-33.612735-21.837782-33.612734-48.469922V512.000993c0-16.6328-13.482982-30.116806-30.115782-30.116805H88.931355L486.573336 71.898935z m503.915566 470.219888c13.750245 0 20.63868-6.01394 26.113997-14.39434a38.754229 38.754229 0 0 0 1.868797-3.184634c6.361076-9.072622 7.731185-21.523414 1.460221-32.394177 0.620543 1.075198-4.531191-9.206766-7.535601-14.126053-3.059706-5.010422-6.388724-9.502702-10.297324-13.553638L580.641889 29.960072C562.265221 10.942381 537.709749-0.243773 512.247014 0.006083c-24.952784-0.249856-50.614174 11.048939-68.932474 29.979589L21.967005 464.41171c-3.93932 4.0622-7.287794 8.568815-10.360812 13.594597-3.018746 4.93567-8.171504 15.234018-7.539697 14.139365-6.267892 10.864619-4.902902 23.306195 1.447933 32.376769a38.764469 38.764469 0 0 0 1.86982 3.190778c5.478389 8.391664 12.354536 14.405604 26.120142 14.405604h101.104444v373.175596c0 56.65781 38.579125 108.705581 93.843273 108.705581h158.091982c16.6328 0 30.115782-13.484006 30.115781-30.11783V684.68085c0-75.034478-0.790526-73.717617 48.551842-73.717617h93.568843c49.334176 0 48.551842-1.302525 48.551841 73.717617v309.20132c0 16.633824 13.482982 30.11783 30.115782 30.11783h158.094029c55.247765 0 93.844298-52.060059 93.844298-108.707629V542.120871h101.102396z"
      p-id="7477"
    />
  </svg>
);

export const MenuIconSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622464530522"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="8312"
  >
    <path
      d="M375.893333 853.333333H89.6c-26.581333 0-46.933333-20.906667-46.933333-48.298666 0-27.392 20.352-48.298667 46.933333-48.298667h286.293333c26.581333 0 46.933333 20.906667 46.933334 48.298667A47.786667 47.786667 0 0 1 375.893333 853.333333zM375.893333 560.298667H89.6c-26.581333 0-46.933333-20.906667-46.933333-48.298667 0-27.392 20.352-48.298667 46.933333-48.298667h286.293333c26.581333 0 46.933333 20.906667 46.933334 48.298667a47.786667 47.786667 0 0 1-46.933334 48.298667zM375.893333 267.264H89.6c-26.581333 0-46.933333-20.906667-46.933333-48.298667C42.666667 191.616 63.018667 170.666667 89.6 170.666667h286.293333c26.581333 0 46.933333 20.906667 46.933334 48.298666a47.786667 47.786667 0 0 1-46.933334 48.298667z"
      p-id="8313"
    />
    <path
      d="M311.765333 853.333333c-26.624 0-46.933333-20.906667-46.933333-48.298666 0-27.392 20.309333-48.298667 46.933333-48.298667H934.4c26.581333 0 46.933333 20.906667 46.933333 48.298667 0 27.349333-20.352 48.298667-46.933333 48.298666H311.765333c1.536 0 1.536 0 0 0zM311.765333 560.298667c-26.624 0-46.933333-20.906667-46.933333-48.298667 0-27.392 20.309333-48.298667 46.933333-48.298667H934.4c26.581333 0 46.933333 20.906667 46.933333 48.298667 0 27.392-20.352 48.298667-46.933333 48.298667H311.765333c1.536 0 1.536 0 0 0zM311.765333 267.264c-26.624 0-46.933333-20.906667-46.933333-48.298667 0-27.349333 20.309333-48.298667 46.933333-48.298666H934.4c26.581333 0 46.933333 20.906667 46.933333 48.298666 0 27.392-20.352 48.298667-46.933333 48.298667H311.765333c1.536 0 1.536 0 0 0z"
      p-id="8314"
    />
  </svg>
);

export const MenuRArrowSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622465065719"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="10581"
  >
    <path
      stroke="grey"
      strokeWidth="90"
      d="M765.7 486.8L314.9 134.7c-5.3-4.1-12.9-0.4-12.9 6.3v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1c16.4-12.8 16.4-37.6 0-50.4z"
      p-id="10582"
    />
  </svg>
);

export const MenuLArrowSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622545672742"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1221"
  >
    <path
      stroke="grey"
      strokeWidth="90"
      d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8c-16.4 12.8-16.4 37.5 0 50.3l450.8 352.1c5.3 4.1 12.9 0.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
      p-id="1222"
    />
  </svg>
);

export const MenuDArrowSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624448566361"
    className="icon"
    viewBox="0 0 1536 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="45113"
  >
    <path d="M1459.2 256L1280 76.8l-512 512-512-512L76.8 256 768 947.2l17.066667-17.066667z" p-id="45114" />
  </svg>
);

export const MenuShareSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622702207340"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1824"
  >
    <path
      d="M371.154 175.42v77.672H201.311V822.69h621.378V524.945h77.672V822.69a77.672 77.672 0 0 1-77.672 77.672H201.311a77.672 77.672 0 0 1-77.672-77.672V253.092a77.672 77.672 0 0 1 77.672-77.672h169.843zM778.753 68.724l183.073 183.048L769.613 444.01l-54.94-54.914 84.223-84.223H706.18c-147.681 0-267.866 117.751-271.75 264.5l-0.103 7.353V680.29h-77.673V576.727c0-193.042 156.484-349.525 349.526-349.525h121.194L723.838 123.639l54.915-54.915z"
      p-id="1825"
    />
  </svg>
);

export const MenuReportsSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1622706312234"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5625"
  >
    <path
      d="M896 480c-1.344 0-2.464 0.608-3.744 0.768-1.28-0.16-2.432-0.768-3.744-0.768H544V132c0-0.704-0.352-1.312-0.416-2.016 0.064-0.672 0.416-1.28 0.416-1.984a32 32 0 0 0-32-32C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416a32 32 0 0 0-32-32zM512 864c-194.08 0-352-157.92-352-352 0-183.296 140.864-334.144 320-350.368V512a32 32 0 0 0 32 32h350.368C846.144 723.136 695.296 864 512 864z m113.664-685.28a355.36 355.36 0 0 1 216.832 211.84 32 32 0 1 0 60.064-22.048 414.24 414.24 0 0 0-256.224-250.336 31.968 31.968 0 1 0-20.672 60.544z"
      p-id="5626"
    />
  </svg>
);

export const MenuUnitSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624360103026"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="35285"
  >
    <path stroke="grey" strokeWidth="9" d="M398.575 565.67H123.21c-33 0-60 27-60 60v273.735c0 33 27 60 60 60h275.364c33 0 60-27 60-60V625.67c0.001-33-26.999-60-59.999-60z m0 333.628a0.901 0.901 0 0 1-0.107 0.107h-275.15a0.901 0.901 0 0 1-0.107-0.107v-273.52a0.901 0.901 0 0 1 0.107-0.107h275.149v-0.001c0.037 0.031 0.076 0.07 0.108 0.108v273.52zM899.21 63.801H623.772c-33 0-60 27-60 60v273.735c0 33 27 60 60 60H899.21c33 0 60-27 60-60V123.801c0-33-27-60-60-60z m0.001 333.628a0.901 0.901 0 0 1-0.107 0.107H623.88a0.901 0.901 0 0 1-0.107-0.107v-273.52a0.901 0.901 0 0 1 0.107-0.107h275.223v-0.001c0.037 0.031 0.076 0.07 0.108 0.108v273.52zM398.649 63.801H123.21c-33 0-60 27-60 60v273.735c0 33 27 60 60 60h275.438c33 0 60-27 60-60V123.801c0.001-33-26.999-60-59.999-60z m0 333.628a0.901 0.901 0 0 1-0.107 0.107H123.318a0.901 0.901 0 0 1-0.107-0.107v-273.52a0.901 0.901 0 0 1 0.107-0.107h275.223v-0.001c0.037 0.031 0.076 0.07 0.108 0.108v273.52zM899.21 565.976h-274c-33 0-60 26.988-60 59.973v273.879c0 32.985 27 59.973 60 59.973h180c16.5 0 30-13.494 30-29.987s-13.5-29.987-30-29.987h-180V625.949h274V808.868c0 16.493 13.5 29.987 30 29.987s30-13.494 30-29.987V625.949c0-32.985-27-59.973-60-59.973z" p-id="35286" />
  </svg>

  /**  <svg
    width={ width }
    height={ height }
    t="1624262005357"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1828"
  >
    <path d="M443.72992 102.4h-307.2A34.22208 34.22208 0 0 0 102.4 136.52992v307.2a34.26304 34.26304 0 0 0 34.12992 34.12992h307.2a34.26304 34.26304 0 0 0 34.14016-34.12992v-307.2A34.23232 34.23232 0 0 0 443.72992 102.4zM409.6 409.6H170.67008V170.67008H409.6V409.6zM887.47008 102.4h-307.2a34.23232 34.23232 0 0 0-34.14016 34.12992v307.2a34.26304 34.26304 0 0 0 34.14016 34.12992h307.2A34.26304 34.26304 0 0 0 921.6 443.72992v-307.2A34.22208 34.22208 0 0 0 887.47008 102.4z m-34.14016 307.2H614.4V170.67008h238.92992V409.6zM443.72992 546.14016h-307.2A34.22208 34.22208 0 0 0 102.4 580.27008v307.2A34.26304 34.26304 0 0 0 136.52992 921.6h307.2a34.26304 34.26304 0 0 0 34.14016-34.12992v-307.2a34.22208 34.22208 0 0 0-34.14016-34.12992z m-34.12992 307.2H170.67008V614.4H409.6v238.94016zM887.47008 546.14016h-307.2a34.22208 34.22208 0 0 0-34.14016 34.12992v307.2A34.26304 34.26304 0 0 0 580.27008 921.6h307.2A34.26304 34.26304 0 0 0 921.6 887.47008v-307.2a34.22208 34.22208 0 0 0-34.12992-34.12992z m-34.14016 307.2H614.4V614.4h238.92992v238.94016z" p-id="1829" />
  </svg>*/

);
export const MenuSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624444934948"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="43336"
  >
    <path d="M128 192l768 0 0 128-768 0 0-128Z" p-id="43337" />
    <path d="M128 448l768 0 0 128-768 0 0-128Z" p-id="43338" />
    <path d="M128 704l768 0 0 128-768 0 0-128Z" p-id="43339" />
  </svg>
);

export const MenuUsersSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262109685"
    className="icon"
    viewBox="0 0 1028 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3987"
  >
    <path d="M554.666667 597.333333H213.333333c-119.466667 0-213.333333 93.866667-213.333333 213.333334v85.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666666-42.666667v-85.333333c0-72.533333 55.466667-128 128-128h341.333334c72.533333 0 128 55.466667 128 128v85.333333c0 25.6 17.066667 42.666667 42.666666 42.666667s42.666667-17.066667 42.666667-42.666667v-85.333333c0-119.466667-93.866667-213.333333-213.333333-213.333334zM384 512c119.466667 0 213.333333-93.866667 213.333333-213.333333s-93.866667-213.333333-213.333333-213.333334-213.333333 93.866667-213.333333 213.333334 93.866667 213.333333 213.333333 213.333333z m0-341.333333c72.533333 0 128 55.466667 128 128s-55.466667 128-128 128-128-55.466667-128-128 55.466667-128 128-128zM866.133333 605.866667c-21.333333-4.266667-46.933333 8.533333-51.2 29.866666s8.533333 46.933333 29.866667 51.2c55.466667 12.8 93.866667 64 98.133333 123.733334v85.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667v-85.333333c-4.266667-98.133333-68.266667-183.466667-162.133334-204.8zM691.2 93.866667c-21.333333-8.533333-42.666667 4.266667-51.2 29.866666-4.266667 21.333333 8.533333 46.933333 29.866667 51.2 68.266667 17.066667 110.933333 85.333333 93.866666 157.866667-12.8 46.933333-46.933333 81.066667-93.866666 93.866667-21.333333 4.266667-38.4 29.866667-29.866667 51.2 4.266667 21.333333 21.333333 34.133333 42.666667 34.133333h8.533333c76.8-21.333333 136.533333-76.8 153.6-153.6 29.866667-119.466667-38.4-238.933333-153.6-264.533333z" p-id="3988" />
  </svg>


);

export const MenuHelpSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262173110"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4799"
  >
    <path d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768z m0 85.333333C252.8 981.333333 42.666667 771.2 42.666667 512S252.8 42.666667 512 42.666667s469.333333 210.133333 469.333333 469.333333-210.133333 469.333333-469.333333 469.333333zM389.973333 370.261333l-21.418666 1.92-6.357334-77.269333 19.2-3.370667c3.84-0.64 26.709333-4.778667 33.109334-5.845333 29.866667-4.992 56.192-6.997333 101.973333-6.997333 91.690667 0 141.994667 38.016 141.994667 113.92 0 42.88-17.834667 68.565333-61.44 106.666666-4.48 3.968-4.48 3.968-8.96 7.808-40.106667 34.986667-54.442667 55.722667-55.637334 90.965334l-0.725333 20.608h-85.205333l-0.341334-20.992c-0.853333-54.912 20.181333-90.752 64.810667-131.925334 1.493333-1.408 20.906667-18.901333 25.898667-23.68 17.664-16.938667 24.832-28.458667 25.173333-41.130666 0.810667-26.496-12.458667-36.565333-56.32-36.565334-34.816 0-56.064 0.768-79.573333 2.645334-7.850667 0.64-46.336 4.138667-36.181334 3.242666zM448 682.666667c0-23.253333 20.48-32.085333 43.434667-32.085334s43.392 8.832 43.392 32.085334v42.666666c0 23.253333-20.48 32.085333-43.434667 32.085334S448 748.586667 448 725.333333v-42.666666z" p-id="4800" />
  </svg>


);
export const MenuMailSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262288554"
    className="icon"
    viewBox="0 0 1025 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7971"
  >
    <path d="M1025.2796 473.931896a65.579506 65.579506 0 0 0-12.796001-30.550453l-1.5995-1.43955a37.428304 37.428304 0 0 0-11.196501-11.196501L582.218057 27.511403a97.88941 97.88941 0 0 0-135.957513 0l-417.469541 399.875039A81.254608 81.254608 0 0 0 0 479.850047v479.850047a63.980006 63.980006 0 0 0 63.980006 63.980006h895.720088a63.980006 63.980006 0 0 0 63.980006-63.980006V481.769447c1.5995-1.9194 1.5995-4.63855 1.5995-7.837551zM271.915027 726.652921L65.579506 916.99344v-371.084037z m65.579506 27.191503c1.5995-1.5995 4.7985-3.199 6.398001-4.798501a1.5995 1.5995 0 0 1 1.5995-1.5995l140.756013-129.559513a39.347704 39.347704 0 0 1 49.584505-1.5995l383.880038 345.492034H113.564511z m420.668541-22.552953l203.13652-179.144017v361.646985z m-652.596064-287.910028l387.079038-371.084036a31.990003 31.990003 0 0 1 22.393002-9.437051 31.990003 31.990003 0 0 1 22.393002 9.437051L898.919088 415.870041h-1.5995l54.383005 55.982505-241.524524 214.812871-135.957513-121.562012a105.72696 105.72696 0 0 0-131.159013 1.5995l-124.761012 115.164012-241.524524-212.733521 28.791003-25.751953z" p-id="7972" />
  </svg>


);
export const MenuRecallSvg = ({ width = 26, height = 26 }) => (

  <svg
    width={ width }
    height={ height }
    t="1633432060205"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="778"
  >
    <path d="M358.4 445.046154c-9.846154-11.815385-3.938462-31.507692 9.846154-35.446154h177.230769c131.938462 0 238.276923 112.246154 226.461539 248.123077-11.815385 116.184615-114.215385 202.830769-232.369231 202.830769H472.615385c-15.753846 0-31.507692 13.784615-31.507693 31.507692v61.046154c0 15.753846 13.784615 31.507692 31.507693 31.507693h70.892307c191.015385 0 344.615385-153.6 348.553846-342.646154 3.938462-194.953846-161.476923-354.461538-356.430769-356.430769h-163.446154s-53.169231 1.969231-19.692307-35.446154l116.184615-114.215385c11.815385-11.815385 11.815385-31.507692 0-43.323077l-43.323077-43.323077c-11.815385-11.815385-31.507692-11.815385-43.323077 0l-275.692307 277.661539c-11.815385 11.815385-11.815385 31.507692 0 43.323077l277.661538 277.661538c11.815385 11.815385 31.507692 11.815385 43.323077 0l43.323077-43.323077c11.815385-11.815385 11.815385-31.507692 0-43.323077l-112.246154-116.184615z" p-id="779" />
  </svg>
);
export const MenuBlockSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262462786"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="13720"
  >
    <path d="M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512S793.6 1024 512 1024zM512 85.333333C277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667S746.666667 85.333333 512 85.333333z" p-id="13721" />
    <path d="M844.8 887.466667c-12.8 0-21.333333-4.266667-29.866667-12.8L149.333333 209.066667c-17.066667-17.066667-17.066667-42.666667 0-59.733333s42.666667-17.066667 59.733333 0l665.6 665.6c17.066667 17.066667 17.066667 42.666667 0 59.733333C866.133333 883.2 853.333333 887.466667 844.8 887.466667z" p-id="13722" />
  </svg>


);
export const MenuErrorMessagesSvg = ({ width = 26, height = 26 }) => (
  <svg
    t="1624262639307"
    width={ width }
    height={ height }
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="19407"
  >
    <path d="M928 128H576l-25.6 6.4-38.4 44.8-38.4-44.8L448 128H96l-32 32v640l32 32h339.2l57.6 57.6h44.8l51.2-57.6h339.2l32-32v-640l-32-32zM467.2 774.4L448 768H128V192h307.2l44.8 44.8v550.4l-12.8-12.8zM896 768H576l-25.6 6.4-6.4 6.4V236.8l44.8-44.8H896v576zM384 320H192v64h192V320z m0 128H192v64h192V448zM192 576h192v64H192V576z m640-256h-192v64h192V320z m-192 128h192v64h-192V448z m0 128h192v64h-192V576z" p-id="19408" />
  </svg>


);

export const MenuPortalSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262890906"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="29073"
  >
    <path d="M632.429714 919.350857c13.293714 14.573714 36.425143 16.292571 52.717715-0.859428 101.997714-106.697143 160.713143-249.856 160.713142-406.272 0-156.434286-57.856-300.854857-160.731428-406.710858-16.274286-17.152-39.424-15.433143-52.699429-0.859428-13.293714 14.994286-10.294857 35.986286 5.138286 52.278857 89.581714 92.16 138.422857 217.709714 138.422857 355.291429 0 137.563429-49.700571 261.851429-138.422857 354.852571-15.433143 16.274286-18.432 37.723429-5.138286 52.297143z m-123.849143-113.993143c13.714286 15.853714 37.705143 15.853714 53.997715-2.139428 71.131429-77.147429 111.414857-180.004571 111.414857-290.998857s-39.424-214.308571-111.414857-290.998858c-16.292571-18.432-40.283429-18.432-53.997715-2.157714-13.714286 15.433143-9.435429 35.584 5.997715 53.156572 57.856 63.414857 89.563429 147.419429 89.563428 240 0 92.141714-32.146286 176.146286-89.563428 240-15.433143 17.554286-19.712 37.284571-5.997715 53.138285z m-120.009142-122.148571c14.134857 15.853714 39.862857 16.274286 54.857142-2.998857 37.302857-46.281143 58.697143-104.996571 58.697143-167.990857 0-63.012571-21.394286-122.148571-58.697143-168.009143-14.994286-19.712-40.722286-19.291429-54.857142-2.998857-13.714286 15.433143-7.716571 34.285714 5.577142 53.138285 25.289143 32.146286 38.144 73.289143 38.144 117.869715 0 44.562286-12.434286 85.705143-38.144 117.851428-13.714286 18.432-19.291429 37.723429-5.577142 53.138286z m-147.437715-110.134857c33.865143 0 62.573714-28.708571 62.573715-62.573715a62.372571 62.372571 0 0 0-62.573715-62.573714c-34.267429 0-62.994286 29.568-62.994285 63.433143 0 32.566857 29.568 61.714286 62.994285 61.714286z" p-id="29074" />
  </svg>


);

export const MenuSystemManagementSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624262964336"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="29889"
  >
    <path d="M880.48 451.488l-14.72-64 54.96-94.976-117.6-146.464-105.28 32L637.92 149.6 597.472 48H409.248l-40.464 101.6-59.904 28.544-105.28-32.064-117.616 146.448 54.96 94.976-14.72 64-90.976 61.872 42.016 182.864 108.944 16.512 41.312 51.456-8.016 109.216 169.696 80.976L470.064 880h66.592l80.864 74.4L787.2 873.328l-8-109.168 41.296-51.424 108.96-16.496 42-182.864-90.992-61.888z m-16.816 173.808l-86 13.056-80.576 100.32 6.336 86.16-71.664 34.08L567.808 800h-128.896l-63.968 58.912-71.664-34.176 6.336-86.112-80.576-100.304-86-13.04-17.568-76.528 71.696-48.768 28.8-125.28-43.296-74.832 49.424-61.552 83.248 25.328 116.224-55.408L463.52 128h79.664l31.952 80.24 116.224 55.488 83.248-25.36 49.424 61.536-43.296 74.816 28.8 125.28 71.712 48.752-17.6 76.544zM504.88 336c-92.64 0-167.968 75.36-167.968 168s75.36 168 168 168 168-75.36 168-168S597.536 336 504.88 336z m0.032 256a88.112 88.112 0 0 1-88-88c0-23.504 9.152-45.6 25.76-62.224A87.392 87.392 0 0 1 504.928 416c48.512 0 88 39.488 88 88s-39.488 88-88 88z" fill="" p-id="29890" />
  </svg>


);

export const MenuOfferDemandSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624263059452"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="30706"
  >
    <path d="M972.081123 293.940718l-115.020281-148.567863C847.475819 132.592824 834.695788 127.800312 821.915757 127.800312H425.734789V43.132605c0-25.560062-15.975039-43.132605-41.535101-43.132605s-43.132605 17.572543-43.132605 43.132605V127.800312h-255.600624c-25.560062 0-43.132605 17.572543-43.132606 43.132605v298.73323c0 25.560062 17.572543 43.132605 43.132606 43.132605h255.600624v468.068643c0 25.560062 17.572543 43.132605 43.132605 43.132605s43.132605-17.572543 43.132605-43.132605V511.201248h396.180968c12.780031 0 25.560062-4.792512 33.547581-17.572543l115.020281-148.567863c12.780031-12.780031 12.780031-38.340094 0-51.120124z m-170.932917 132.592823H128.599064V212.468019h672.549142l81.472699 107.032761-81.472699 107.032761z" p-id="30707" />
  </svg>
);


// export const MenuSvg = ({ width = 26, height = 26 }) => (
//   width={ width }
//   height={ height }
//
// );

export const CheckSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624443321993"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="39332"
  >
    <path d="M1002.88 321.92L405.76 935.04a32 32 0 0 1-45.76 0L21.12 612.48a32 32 0 0 1 0-44.8L160 433.6a32 32 0 0 1 45.76 0L359.04 576 796.16 120.64a32 32 0 0 1 46.08 0l160 156.48a32 32 0 0 1 0.64 44.8z" p-id="39333" />
  </svg>
);

export const LightCheckSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1628507558597"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1331"
  >
    <path d="M369.792 704.32L930.304 128 1024 223.616 369.984 896l-20.288-20.864-0.128 0.128L0 516.8l96.128-93.12 273.664 280.64z" p-id="1332" />
  </svg>


);

export const WhiteCheckSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1331"
  >
    <path d="M369.792 704.32L930.304 128 1024 223.616 369.984 896l-20.288-20.864-0.128 0.128L0 516.8l96.128-93.12 273.664 280.64z" p-id="1332" fill="#ffffff" />
  </svg>
);

export const CrossSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624443335848"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="40187"
  >
    <path d="M1014.643493 822.632271c0 0 0 0-0.020479 0l-310.629747-310.629747 310.629747-310.629747c0 0 0 0 0.020479 0 3.338123-3.338123 5.754678-7.249666 7.311104-11.40696 4.239211-11.366001 1.822656-24.677535-7.331583-33.831774l-146.734054-146.734054c-9.154239-9.154239-22.445293-11.570794-33.831774-7.311104-4.157294 1.556425-8.068837 3.972981-11.427439 7.311104 0 0 0 0 0 0l-310.629747 310.650226-310.629747-310.629747c0 0 0 0 0 0-3.338123-3.338123-7.249666-5.754678-11.40696-7.311104-11.386481-4.239211-24.677535-1.822656-33.831774 7.311104l-146.734054 146.734054c-9.154239 9.154239-11.570794 22.445293-7.331583 33.831774 1.556425 4.157294 3.972981 8.068837 7.311104 11.40696 0 0 0 0 0 0l310.629747 310.629747-310.629747 310.650226c0 0 0 0 0 0-3.338123 3.338123-5.754678 7.249666-7.311104 11.40696-4.239211 11.366001-1.822656 24.677535 7.331583 33.831774l146.734054 146.734054c9.154239 9.154239 22.445293 11.570794 33.831774 7.331583 4.157294-1.556425 8.068837-3.972981 11.40696-7.311104 0 0 0 0 0 0l310.629747-310.629747 310.629747 310.629747c0 0 0 0 0.020479 0 3.338123 3.338123 7.249666 5.754678 11.40696 7.311104 11.386481 4.239211 24.677535 1.822656 33.831774-7.331583l146.734054-146.734054c9.154239-9.154239 11.570794-22.445293 7.331583-33.831774-1.556425-4.157294-3.972981-8.068837-7.311104-11.40696z" p-id="40188" />
  </svg>
);

export const WhiteCrossSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    p-id="40187"
  >
    <path d="M1014.643493 822.632271c0 0 0 0-0.020479 0l-310.629747-310.629747 310.629747-310.629747c0 0 0 0 0.020479 0 3.338123-3.338123 5.754678-7.249666 7.311104-11.40696 4.239211-11.366001 1.822656-24.677535-7.331583-33.831774l-146.734054-146.734054c-9.154239-9.154239-22.445293-11.570794-33.831774-7.311104-4.157294 1.556425-8.068837 3.972981-11.427439 7.311104 0 0 0 0 0 0l-310.629747 310.650226-310.629747-310.629747c0 0 0 0 0 0-3.338123-3.338123-7.249666-5.754678-11.40696-7.311104-11.386481-4.239211-24.677535-1.822656-33.831774 7.311104l-146.734054 146.734054c-9.154239 9.154239-11.570794 22.445293-7.331583 33.831774 1.556425 4.157294 3.972981 8.068837 7.311104 11.40696 0 0 0 0 0 0l310.629747 310.629747-310.629747 310.650226c0 0 0 0 0 0-3.338123 3.338123-5.754678 7.249666-7.311104 11.40696-4.239211 11.366001-1.822656 24.677535 7.331583 33.831774l146.734054 146.734054c9.154239 9.154239 22.445293 11.570794 33.831774 7.331583 4.157294-1.556425 8.068837-3.972981 11.40696-7.311104 0 0 0 0 0 0l310.629747-310.629747 310.629747 310.629747c0 0 0 0 0.020479 0 3.338123 3.338123 7.249666 5.754678 11.40696 7.311104 11.386481 4.239211 24.677535 1.822656 33.831774-7.331583l146.734054-146.734054c9.154239-9.154239 11.570794-22.445293 7.331583-33.831774-1.556425-4.157294-3.972981-8.068837-7.311104-11.40696z" p-id="40188" fill="#ffffff" />
  </svg>
);

export const SearchSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624444081408"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="41099"
  >
    <path stroke="white" strokeWidth="70" d="M875.264 855.872l-188.032-215.552C737.664 579.392 768 501.248 768 416 768 221.632 610.368 64 416 64 221.568 64 64 221.632 64 416S221.568 768 416 768c72.32 0 139.52-21.888 195.392-59.264l186.88 214.272c18.496 21.312 50.88 23.36 72 4.928C891.648 909.376 893.76 877.12 875.264 855.872zM160 416c0-141.184 114.816-256 256-256 141.184 0 256 114.816 256 256s-114.816 256-256 256C274.816 672 160 557.184 160 416z" p-id="41100" />
  </svg>

);

export const PlusSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1624446010285"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="44123"
  >
    <path d="M914.285714 420.571429l0 109.714286q0 22.820571-16.018286 38.838857t-38.838857 16.018286l-237.714286 0 0 237.714286q0 22.820571-16.018286 38.838857t-38.838857 16.018286l-109.714286 0q-22.820571 0-38.838857-16.018286t-16.018286-38.838857l0-237.714286-237.714286 0q-22.820571 0-38.838857-16.018286t-16.018286-38.838857l0-109.714286q0-22.820571 16.018286-38.838857t38.838857-16.018286l237.714286 0 0-237.714286q0-22.820571 16.018286-38.838857t38.838857-16.018286l109.714286 0q22.820571 0 38.838857 16.018286t16.018286 38.838857l0 237.714286 237.714286 0q22.820571 0 38.838857 16.018286t16.018286 38.838857z" p-id="44124" />
  </svg>

);


export const QuestionSvg = ({ width = 18, height = 18 }) => (
  <svg
    t="1625828978560"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1330"
    width={ width }
    height={ height }
  >
    <path d="M512 56.889344c251.334656 0 455.110656 203.776 455.110656 455.110656 0 251.334656-203.776 455.110656-455.110656 455.110656-251.334656 0-455.110656-203.776-455.110656-455.110656 0-251.334656 203.776-455.110656 455.110656-455.110656z m-4.056064 593.276928c-13.084672 0-23.779328 3.753984-31.857664 12.515328-9.443328 8.078336-13.824 18.772992-13.824 31.857664 0 12.515328 4.380672 23.153664 13.824 31.915008 8.078336 8.704 18.772992 13.084672 31.85664 13.084672 12.573696 0 23.780352-4.380672 33.16736-12.459008 8.704-8.817664 13.084672-19.39968 13.084672-32.540672 0-13.084672-4.380672-23.779328-13.084672-31.857664-8.761344-8.761344-20.025344-12.515328-33.16736-12.515328z m10.667008-365.7216c-45.682688 0-81.92 13.084672-108.146688 39.99232-26.907648 26.283008-39.99232 61.89568-39.99232 107.577344v1.024c0 18.374656 14.790656 33.222656 33.166336 33.222656 18.318336 0 33.166336-14.848 33.166336-33.222656 0-0.398336-0.113664-1.024-0.113664-1.024 0-27.59168 5.574656-49.379328 16.838656-64.398336 12.515328-17.521664 33.108992-26.283008 61.326336-26.283008 22.470656 0 39.99232 6.257664 52.451328 18.774016 11.889664 12.515328 18.204672 29.411328 18.204672 51.25632 0 16.27136-5.689344 31.232-16.953344 45.625344l-10.638336 11.88864c-38.683648 34.361344-61.780992 60.416-71.28064 77.484032-14.166016 25.542656-11.606016 49.152-11.606016 49.152 0 18.317312 14.905344 33.165312 33.222656 33.165312 18.37568 0 30.492672-12.628992 33.16736-33.165312 0 0 3.412992-19.115008 10.29632-31.63136 5.632-11.206656 14.39232-21.901312 25.6-31.85664 30.094336-25.657344 47.558656-41.92768 53.134336-48.811008 15.017984-19.968 23.09632-45.625344 23.09632-76.23168 0-37.48864-12.457984-67.526656-36.806656-89.428992-25.03168-22.470656-57.515008-33.108992-98.132992-33.108992z" p-id="1331" />
  </svg>
);


export const LanguagesSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1625831739314"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2902"
  >
    <path d="M511.786667 85.333333C276.053333 85.333333 85.333333 276.266667 85.333333 512s190.72 426.666667 426.453334 426.666667C747.52 938.666667 938.666667 747.733333 938.666667 512S747.52 85.333333 511.786667 85.333333z m295.466666 256h-125.866666c-13.866667-53.333333-33.28-104.533333-58.88-151.893333 78.506667 26.88 143.786667 81.28 184.746666 151.893333zM512 172.16c35.626667 51.2 63.36 108.16 81.493333 169.173333h-162.986666c18.133333-61.013333 45.866667-117.973333 81.493333-169.173333zM181.76 597.333333C174.72 570.026667 170.666667 541.44 170.666667 512s4.053333-58.026667 11.093333-85.333333h144c-3.413333 27.946667-5.76 56.32-5.76 85.333333 0 29.013333 2.346667 57.386667 5.973333 85.333333H181.76z m34.773333 85.333334h125.866667c13.866667 53.333333 33.28 104.533333 58.88 152.106666A342.058667 342.058667 0 0 1 216.533333 682.666667z m125.866667-341.333334h-125.866667c40.96-70.613333 106.24-125.226667 184.746667-152.106666-25.6 47.573333-45.013333 98.773333-58.88 152.106666zM512 851.84c-35.413333-51.2-63.146667-108.16-81.493333-169.173333h162.986666c-18.346667 61.013333-46.08 117.973333-81.493333 169.173333zM611.84 597.333333h-199.68c-4.053333-27.946667-6.826667-56.32-6.826667-85.333333 0-29.013333 2.773333-57.386667 6.826667-85.333333h199.68c4.053333 27.946667 6.826667 56.32 6.826667 85.333333 0 29.013333-2.773333 57.386667-6.826667 85.333333z m10.88 237.226667c25.6-47.573333 45.013333-98.56 58.88-151.893333h125.866667a343.189333 343.189333 0 0 1-184.746667 151.893333zM698.026667 597.333333c3.413333-27.946667 5.973333-56.32 5.973333-85.333333 0-29.013333-2.346667-57.386667-5.973333-85.333333h144c7.04 27.306667 11.306667 55.893333 11.306666 85.333333s-4.053333 58.026667-11.306666 85.333333h-144z" p-id="2903" />
  </svg>
);

export const LogoutSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1625831889884"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3742"
  >
    <path d="M733.726 647.766 778.98 693.02 960 512 778.98 330.98 733.724 376.236 837.49 480 384 480 384 544 837.49 544Z" p-id="3743" />
    <path d="M782.982 783.532C710.458 856.058 614.036 896 511.472 896c-102.574 0-199.012-39.942-271.544-112.47C167.394 711.002 128 614.57 128 512c0-102.562 39.394-198.99 111.93-271.522C312.464 167.946 408.9 128 511.472 128c102.558 0 198.982 39.946 271.51 112.476 5.054 5.056 9.932 10.242 14.666 15.524l81.462 0c-80.948-116.056-215.418-192-367.638-192C264.042 64 64 264.596 64 512c0 247.43 200.042 448 447.472 448 152.224 0 286.7-75.94 367.644-192l-81.46 0C792.92 773.286 788.042 778.472 782.982 783.532z" p-id="3744" />
  </svg>
);


export const StackSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1638692810438"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1891"
  >
    <path d="M856.874667 648.533333l51.285333 30.762667a21.333333 21.333333 0 0 1 0 36.608l-374.186667 224.512a42.666667 42.666667 0 0 1-43.946666 0l-374.186667-224.512a21.333333 21.333333 0 0 1 0-36.608l51.285333-30.762667L512 855.466667l344.874667-206.933334z m0-200.533333l51.285333 30.762667a21.333333 21.333333 0 0 1 0 36.608L512 753.066667l-396.16-237.696a21.333333 21.333333 0 0 1 0-36.608l51.285333-30.762667L512 654.933333l344.874667-206.933333z m-322.944-392.149333l374.229333 224.512a21.333333 21.333333 0 0 1 0 36.608L512 554.666667 115.84 316.970667a21.333333 21.333333 0 0 1 0-36.608l374.186667-224.512a42.666667 42.666667 0 0 1 43.946666 0zM512 142.165333L251.178667 298.666667 512 455.168 772.821333 298.666667 512 142.165333z" p-id="1892" />

  </svg>
);

export const MonitorSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1627817827483"
    className="icon"
    viewBox="0 0 1152 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1289"
  >
    <path d="M1056 0H96C43 0 0 43 0 96v640c0 53 43 96 96 96h384l-32 96h-144c-26.6 0-48 21.4-48 48s21.4 48 48 48h544c26.6 0 48-21.4 48-48s-21.4-48-48-48h-144l-32-96h384c53 0 96-43 96-96V96c0-53-43-96-96-96z m-32 704H128V128h896v576z" fill="" p-id="1290" />
  </svg>
);


export const UserSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1628590599159"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2580"
  >
    <path d="M486.4 85.333333c34.133333 0 55.466667 6.4 72.533333 12.8C571.733333 100.266667 582.4 104.533333 597.333333 106.666667c4.266667 0 10.666667 0 17.066667 0 14.933333 0 25.6-2.133333 36.266667-4.266667l-6.4 27.733333 19.2 29.866667c17.066667 25.6 17.066667 76.8 14.933333 138.666667l0 34.133333 23.466667 25.6c4.266667 4.266667 6.4 12.8 6.4 21.333333l0 2.133333 0 2.133333c2.133333 19.2-6.4 44.8-25.6 57.6L661.333333 462.933333 652.8 490.666667c-8.533333 36.266667-21.333333 68.266667-32 89.6l-32 61.866667 55.466667 42.666667c19.2 14.933333 49.066667 36.266667 89.6 53.333333l2.133333 0 2.133333 0c102.4 38.4 177.066667 96 177.066667 136.533333L915.2 938.666667 106.666667 938.666667l0-59.733333c0-40.533333 74.666667-100.266667 179.2-138.666667l2.133333 0 2.133333 0c40.533333-17.066667 70.4-38.4 89.6-53.333333l55.466667-42.666667-32-61.866667c-10.666667-21.333333-21.333333-53.333333-32-89.6L362.666667 460.8l-23.466667-17.066667c-21.333333-17.066667-25.6-49.066667-23.466667-59.733333l0-2.133333 0-2.133333c0-6.4 2.133333-14.933333 6.4-19.2l23.466667-27.733333L341.333333 296.533333C337.066667 251.733333 337.066667 170.666667 377.6 149.333333l23.466667-12.8 12.8-23.466667C422.4 96 450.133333 85.333333 486.4 85.333333M486.4 0c-70.4 0-123.733333 27.733333-149.333333 74.666667-87.466667 46.933333-85.333333 166.4-81.066667 230.4-17.066667 19.2-25.6 44.8-27.733333 74.666667-2.133333 34.133333 8.533333 96 57.6 132.266667 8.533333 34.133333 21.333333 74.666667 38.4 106.666667-14.933333 10.666667-38.4 27.733333-70.4 42.666667C198.4 682.666667 21.333333 759.466667 21.333333 878.933333l0 72.533333C21.333333 992 53.333333 1024 93.866667 1024l836.266667 0c40.533333 0 72.533333-32 72.533333-72.533333l0-72.533333c0-121.6-177.066667-196.266667-232.533333-217.6-32-14.933333-57.6-32-72.533333-42.666667 17.066667-32 29.866667-72.533333 38.4-108.8 42.666667-34.133333 59.733333-87.466667 57.6-130.133333 0-32-10.666667-59.733333-29.866667-78.933333 2.133333-81.066667 0-140.8-29.866667-187.733333 4.266667-14.933333 4.266667-27.733333 4.266667-32C738.133333 57.6 725.333333 34.133333 704 21.333333c-12.8-6.4-25.6-10.666667-38.4-10.666667-10.666667 0-21.333333 2.133333-29.866667 6.4-2.133333 2.133333-12.8 4.266667-21.333333 4.266667-2.133333 0-4.266667 0-4.266667 0-6.4 0-14.933333-2.133333-23.466667-6.4C563.2 8.533333 533.333333 0 486.4 0L486.4 0z" p-id="2581" />
  </svg>

);

export const PasswordSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1628590836144"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4803"
  >
    <path d="M512 102.391573c121.179822 0 219.430498 91.686249 219.430498 204.796629l109.712721 0c0-169.648717-147.356632-307.188203-329.143218-307.188203s-329.148274 137.539486-329.148274 307.188203l109.717777 0C292.562761 194.077822 390.813437 102.391573 512 102.391573L512 102.391573 512 102.391573zM877.720305 375.470037l-731.44061 0c-40.394398 0-73.147432 30.57388-73.147432 68.256555L73.132264 955.709738c0 37.716381 32.746293 68.290262 73.147432 68.290262l731.447351 0c40.3826 0 73.14069-30.57388 73.14069-68.290262L950.867736 443.719851C950.869422 406.043918 918.116388 375.470037 877.720305 375.470037L877.720305 375.470037 877.720305 375.470037zM889.696381 957.297335c0 7.767764-6.353758 14.121523-14.121523 14.121523l-723.679587 0c-7.767764 0-14.114781-6.353758-14.114781-14.121523L137.78049 452.508935c0-7.761023 6.347017-14.121523 14.114781-14.121523l723.679587 0c7.761023 0 14.121523 6.353758 14.121523 14.121523L889.696381 957.297335 889.696381 957.297335zM512 546.131648l0-0.006741c-60.61182 0-109.719462 45.833012-109.719462 102.398315 0 37.795592 22.21793 70.474471 54.864787 88.184098l0 97.433282c0 29.422788 24.570674 53.321009 54.859731 53.321009 30.277259 0 54.859731-23.898221 54.859731-53.321009l0-97.433282c32.640116-17.709627 54.85299-50.388505 54.85299-88.184098 0-56.558561-49.105956-102.391573-109.712721-102.391573l0 0L512 546.131648zM512 546.131648" p-id="4804" />
  </svg>
);

export const CsvSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1632629589568"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3104"
  >
    <path d="M897.071735 303.104102L645.782782 26.376259a33.304644 33.304644 0 0 0-24.651805-11.368155h-411.118132c-26.130454 0-49.325261 11.667451-66.078197 30.096446-16.774588 18.453193-27.127683 44.218124-27.127683 72.186383v789.145584c0 28.217885 10.356916 54.255367 27.127683 72.160911 17.001289 18.729564 40.197368 30.400836 66.07565 30.400836h604.208652c25.151056 0 48.322937-11.417825 65.098798-28.769354l0.500525-1.627661c17.253461-18.427721 27.382403-43.939205 27.382404-72.160912V330.245795a39.527455 39.527455 0 0 0-10.128942-27.141693z m-254.974752-172.542255l160.786925 176.072675h-123.321429c-10.356916 0-19.712783-4.056417-26.130455-12.193448l-1.481197-0.82402a43.183961 43.183961 0 0 1-9.856392-27.944061V130.561847z m195.819845 775.877217a27.262685 27.262685 0 0 1-6.920743 18.178095v0.550195a24.398358 24.398358 0 0 1-16.774588 7.337211H210.010298a21.947952 21.947952 0 0 1-16.775861-7.612309v-0.275097a26.169936 26.169936 0 0 1-6.896545-18.178095V117.292207a26.618243 26.618243 0 0 1 6.896545-18.178095 23.420233 23.420233 0 0 1 16.775861-7.335937h390.636094v173.892271a94.702361 94.702361 0 0 0 21.691958 60.518932l1.501574 0.801095c14.294888 16.275336 33.778423 25.764931 55.721281 25.764931H837.914281v553.681113zM240.602174 439.288893v306.555559c0 12.468546 9.126619 22.784707 20.212035 22.784706h502.121957c11.335041 0 20.690908-10.316161 20.690908-22.784706v-306.555559c0-12.468546-9.354593-23.035606-20.690908-23.035606H260.814209c-11.080321 0-20.212035 10.570881-20.212035 23.035606z m375.839407 23.061078h125.280227v107.14034h-125.278953v-107.14034z m0 153.261223h125.280227v107.165812h-125.278953v-107.165812zM449.235711 462.349971h125.280226v107.14034h-125.280226v-107.14034z m0 153.261223h125.280226v107.165812h-125.280226v-107.165812zM282.027293 462.349971h125.280227v107.14034h-125.280227v-107.14034z m0 153.261223h125.280227v107.165812h-125.280227v-107.165812z" p-id="3105" />
  </svg>
);

export const EditSvg = ({ width = 17, height = 17 }) => (
  <svg
    width={ width }
    height={ height }
    t="1632643995830"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2592"
  >
    <path d="M913.58168 384.689453c-25.367761 0-45.933145 20.565385-45.933145 45.933145l0 408.214239L156.047544 838.836837 156.047544 189.407837l375.434671 0c25.368784 0 45.933145-20.565385 45.933145-45.933145 0-25.368784-20.564361-45.934169-45.933145-45.934169L110.079606 97.540524c-25.367761 0-45.933145 20.565385-45.933145 45.934169 0 0.450255 0.021489 0.895393 0.033769 1.343601l0 738.607064c-0.013303 0.448208-0.033769 0.893346-0.033769 1.343601 0 25.367761 20.565385 45.933145 45.933145 45.933145l803.095821 0c0.067538 0 0.135076-0.005117 0.202615-0.005117 0.068562 0 0.1361 0.005117 0.203638 0.005117 25.368784 0 45.934169-20.564361 45.934169-45.933145L959.515848 430.622598C959.515848 405.254837 938.950464 384.689453 913.58168 384.689453z" p-id="2593" />
    <path d="M531.852652 611.321076l412.139641-414.500409c19.783579-19.783579 19.784602-51.861158 0-71.64576l-46.322002-46.322002c-19.785625-19.784602-51.863205-19.784602-71.647807 0L413.88489 493.351268 531.852652 611.321076z" p-id="2594" />
    <path d="M373.206422 656.067186 508.80268 631.659287 397.613298 520.471952Z" p-id="2595" />
  </svg>
);

export const DuplicateSvg = ({ width = 19, height = 19 }) => (
  <svg
    width={ width }
    height={ height }
    t="1632640219962"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1640"
  >
    <path d="M469.333333 426.666667H384v128H256v85.333333h128v128h85.333333v-128h128v-85.333333h-128z" fill="" p-id="1641" />
    <path d="M128 938.666667h597.333333a42.666667 42.666667 0 0 0 42.666667-42.666667V298.666667a42.666667 42.666667 0 0 0-42.666667-42.666667H128a42.666667 42.666667 0 0 0-42.666667 42.666667v597.333333a42.666667 42.666667 0 0 0 42.666667 42.666667zM170.666667 341.333333h512v512H170.666667V341.333333z" fill="" p-id="1642" />
    <path d="M896 85.333333H341.333333v85.333334h512v512h85.333334V128a42.666667 42.666667 0 0 0-42.666667-42.666667z" fill="" p-id="1643" />
  </svg>
);

export const Max = ({ width = 36, height = 36 }) => (
  <svg
    width={ width }
    height={ height }
    t="1633434773025"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="24923"
  >
    <path d="M893 407.79a413.6 413.6 0 1 0-673.39 453.35 26 26 0 0 0 36.77-36.77 361.5 361.5 0 1 1 511.24 0 26 26 0 0 0 36.77 36.77A413.9 413.9 0 0 0 893 407.79z" p-id="24924" />
    <path d="M726.1 354.65A300.8 300.8 0 0 0 512 266a26 26 0 0 0 0 52 250.78 250.78 0 0 1 177.33 428.08 26 26 0 0 0 36.77 36.77 302.77 302.77 0 0 0 0-428.2zM488.29 491.09a52.59 52.59 0 0 0-10.44 73.64c17.45 23.21 164.35 131.1 164.35 131.1s-62.82-171.09-80.28-194.3a52.58 52.58 0 0 0-73.63-10.44z" p-id="24925" />
  </svg>
);

export const EstablishmentsSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1634451946001"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1226"
  >
    <path d="M160 85.333333h448a32 32 0 0 1 31.701333 27.648L640 117.333333V213.333333h224a32 32 0 0 1 32 32V917.333333a21.333333 21.333333 0 0 1-21.333333 21.333334h-128a21.333333 21.333333 0 0 1-21.333334-21.333334V768h-128v149.333333a21.333333 21.333333 0 0 1-21.333333 21.333334h-128a21.333333 21.333333 0 0 1-21.333333-21.333334V245.333333a32 32 0 0 1 32-32h117.333333V149.333333h-384v757.333334a32 32 0 0 1-63.701333 4.352L128 906.666667V117.333333a32 32 0 0 1 27.648-31.701333L160 85.333333zM341.333333 725.333333v85.333334H256v-85.333334h85.333333z m0-128v85.333334H256v-85.333334h85.333333z m298.666667 0h-85.333333v85.333334h85.333333v-85.333334z m128 0h-85.333333v85.333334h85.333333v-85.333334zM341.333333 469.333333v85.333334H256v-85.333334h85.333333z m298.666667 0h-85.333333v85.333334h85.333333v-85.333334z m128 0h-85.333333v85.333334h85.333333v-85.333334zM341.333333 341.333333v85.333334H256V341.333333h85.333333z m298.666667 0h-85.333333v85.333334h85.333333V341.333333z m128 0h-85.333333v85.333334h85.333333V341.333333zM341.333333 213.333333v85.333334H256V213.333333h85.333333z" p-id="1227" />
  </svg>
);

export const MoreSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1635142136203"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1869"
  >
    <path d="M227.14123 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C321.728492 456.087573 279.288914 413.647995 227.14123 413.647995z" p-id="1870" />
    <path d="M510.903016 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C605.490278 456.087573 563.051723 413.647995 510.903016 413.647995z" p-id="1871" />
    <path d="M794.665825 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C889.253086 456.087573 846.813508 413.647995 794.665825 413.647995z" p-id="1872" />
  </svg>
);

export const SwitchSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1635146167255"
    className="icon"
    viewBox="0 0 1128 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4113"
  >
    <path d="M230.941447 409.675993L0.569944 204.875993 230.941447 0v153.656994h895.914508v102.4H230.941447v153.618999z m666.644898 204.724007l230.371503 204.8-230.371503 204.8V870.418998H1.671837v-102.4h895.762523v-153.618998z" p-id="4114" />
  </svg>
);

export const ResetPasswordSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1635146307923"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4998"
  >
    <path d="M677.972 306.674c-5.755 18.454 4.54 38.078 22.994 43.833l145.925 45.504a34.975 34.975 0 0 0 10.43 1.596c14.91 0 28.729-9.605 33.402-24.59l45.505-145.925c5.755-18.454-4.54-38.078-22.993-43.833-18.458-5.754-38.079 4.54-43.833 22.994l-18.179 58.295c-53.145-70.429-127.589-122.543-214.128-148.975-54.454-16.63-110.625-22.318-166.947-16.906-54.396 5.228-106.631 20.54-155.255 45.512-48.674 24.999-91.297 58.427-126.684 99.357-36.699 42.449-63.952 91.117-81.001 144.652-16.867 52.963-22.76 107.61-17.515 162.422 5.062 52.909 20.249 103.799 45.138 151.254 25.44 48.507 59.709 90.975 101.857 126.226 43.591 36.457 93.642 63.479 148.757 80.313 41.194 12.587 83.324 18.911 125.754 18.911 15.261 0 30.561-0.818 45.868-2.457 55.889-5.984 109.291-22.58 158.709-49.317 95.952-51.855 166.823-136.978 199.559-239.688 5.869-18.417-4.303-38.105-22.72-43.976-18.417-5.866-38.105 4.302-43.976 22.72-27.205 85.361-86.21 156.162-166.159 199.369-41.379 22.388-86.081 36.28-132.866 41.289-48.429 5.188-96.782 0.545-143.717-13.798-46.113-14.084-87.934-36.647-124.3-67.062-35.087-29.346-63.609-64.688-84.774-105.042-42.406-80.855-50.544-173.165-22.915-259.922 28.026-88.005 89.454-160.092 172.966-202.983 83.713-42.995 179.521-51.492 269.774-23.926 72.223 22.059 134.31 65.455 178.597 124.06l-73.44-22.901c-18.453-5.755-38.078 4.54-43.833 22.994z" p-id="4999" />
    <path d="M680.423 441.757v-12.264c0-97.872-79.624-177.496-177.496-177.496-70.253 0-134.016 41.544-162.442 105.837-7.816 17.679 0.179 38.348 17.858 46.164s38.348-0.178 46.164-17.858c17.228-38.966 55.861-64.144 98.421-64.144 59.273 0 107.496 48.223 107.496 107.496v0.467H348.397c-39.345 0-71.355 31.238-71.355 69.635v208.957c0 38.396 32.01 69.635 71.355 69.635h292.336c39.346 0 71.355-31.238 71.355-69.635V499.595c0.001-24.072-12.583-45.327-31.665-57.838z m-38.334 266.102c-0.24 0.148-0.671 0.327-1.355 0.327H348.397c-0.685 0-1.115-0.179-1.355-0.327V500.287c0.24-0.149 0.67-0.327 1.355-0.327h292.336c0.685 0 1.115 0.178 1.355 0.327v207.572z" p-id="5000" />
    <path d="M553.276 573.989c0-28.989-23.527-52.517-52.517-52.517S448.243 545 448.243 573.989c0 15.546 6.771 29.515 17.517 39.133v38.099c0 19.33 15.67 35 35 35s35-15.67 35-35v-38.1c10.745-9.618 17.516-23.587 17.516-39.132z" p-id="5001" />
  </svg>
);

export const HistorySvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1635146383053"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5808"
  >
    <path d="M411.733333 885.333333H192c-6.4 0-10.666667-4.266667-10.666667-10.666666V149.333333c0-6.4 4.266667-10.666667 10.666667-10.666666h576c6.4 0 10.666667 4.266667 10.666667 10.666666v219.733334c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V149.333333c0-40.533333-34.133333-74.666667-74.666667-74.666666H192C151.466667 74.666667 117.333333 108.8 117.333333 149.333333v725.333334c0 40.533333 34.133333 74.666667 74.666667 74.666666h219.733333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32z" p-id="5809" />
    <path d="M704 458.666667c-134.4 0-245.333333 110.933333-245.333333 245.333333S569.6 949.333333 704 949.333333 949.333333 838.4 949.333333 704 838.4 458.666667 704 458.666667z m0 426.666666c-100.266667 0-181.333333-81.066667-181.333333-181.333333s81.066667-181.333333 181.333333-181.333333 181.333333 81.066667 181.333333 181.333333-81.066667 181.333333-181.333333 181.333333z" p-id="5810" />
    <path d="M802.133333 716.8l-66.133333-29.866667V597.333333c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v110.933334c0 12.8 8.533333 23.466667 19.2 29.866666l85.333333 38.4c4.266667 2.133333 8.533333 2.133333 12.8 2.133334 12.8 0 23.466667-6.4 29.866667-19.2 6.4-17.066667 0-34.133333-17.066667-42.666667zM693.333333 298.666667c0-17.066667-14.933333-32-32-32H298.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h362.666666c17.066667 0 32-14.933333 32-32zM298.666667 437.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h106.666666c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32h-106.666666z" p-id="5811" />
  </svg>
);

export const DemandOfferSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1637643418978"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6450"
  >
    <path d="M689.802261 0a55.91984 55.91984 0 0 1 32.833667 21.547094 51.302605 51.302605 0 0 1 8.721443 29.755511v51.302605h88.240481a74.388778 74.388778 0 0 1 31.807615 3.078157 51.302605 51.302605 0 0 1 33.859719 48.224449v265.747495a41.55511 41.55511 0 0 1-35.911823 41.042084h-5.130261a41.042084 41.042084 0 0 1-41.042084-41.042084V184.176353H733.409475a47.711423 47.711423 0 0 0-11.799599 0c-4.617234 3.078156-8.208417 7.695391-12.825652 10.773547a51.302605 51.302605 0 0 1-28.729458 10.260521H273.225106a51.302605 51.302605 0 0 1-30.268537-8.721443c-4.617234-3.078156-8.208417-7.695391-13.338677-10.773547a44.12024 44.12024 0 0 0-11.799599 0H148.559776v756.200401h235.478957a41.042084 41.042084 0 0 1 0 82.084168H108.543743a56.945892 56.945892 0 0 1-33.346693-23.086172 51.302605 51.302605 0 0 1-10.773547-34.372746V153.907816a51.302605 51.302605 0 0 1 2.56513-17.955912A51.302605 51.302605 0 0 1 103.413483 102.60521a79.006012 79.006012 0 0 1 24.62525 0h90.292586V51.302605a51.302605 51.302605 0 0 1 11.286573-29.755511A57.971944 57.971944 0 0 1 262.451559 0z m221.627254 542.781563H929.898453a40.529058 40.529058 0 0 1 27.190381 34.372746v42.581162a37.450902 37.450902 0 0 1-8.721443 20.008016 36.937876 36.937876 0 0 1-47.711423 7.182365 38.476954 38.476954 0 0 1-17.442886-30.781563h-300.12024v302.68537c102.60521 2.56513 201.106212 2.56513 300.12024 2.565131a56.432866 56.432866 0 0 1 15.903808-29.755511 36.937876 36.937876 0 0 1 40.016032-5.130261 36.42485 36.42485 0 0 1 20.521042 29.242485v41.042084a41.55511 41.55511 0 0 1-44.633267 38.476954h-359.118236a42.581162 42.581162 0 0 1-32.833667-11.799599 46.172345 46.172345 0 0 1-12.312626-33.346694v-366.813627a46.685371 46.685371 0 0 1 0.513026-18.981964 42.068136 42.068136 0 0 1 38.476954-22.06012h361.683367z m-85.162325 102.605211a38.476954 38.476954 0 0 1 27.703407 13.338677l89.779559 89.779559 4.617235 4.617234a32.320641 32.320641 0 0 1 8.208417 17.442886 31.294589 31.294589 0 0 1-8.721443 26.677355l-96.448898 95.935872-4.104208 4.104208a37.963928 37.963928 0 0 1-36.937876 4.104209 37.963928 37.963928 0 0 1-19.49499-47.198397 41.55511 41.55511 0 0 1 11.286573-15.903808l22.06012-22.573146h-160.577154a42.068136 42.068136 0 0 1-29.755511-20.008016 41.042084 41.042084 0 0 1 0-40.529058 40.016032 40.016032 0 0 1 34.372745-20.521042h153.907816l-20.521042-21.034069a40.529058 40.529058 0 0 1-14.877756-27.19038 36.937876 36.937876 0 0 1 32.320642-40.529058h5.13026zM269.633924 539.703407h116.456914a40.529058 40.529058 0 0 1 37.450901 40.016032 40.016032 40.016032 0 0 1-26.164328 38.98998 68.232465 68.232465 0 0 1-28.729459 3.078156H275.27721a67.206413 67.206413 0 0 1-28.729458-3.078156 40.016032 40.016032 0 0 1-28.216433-38.98998 40.529058 40.529058 0 0 1 29.242485-37.963928 74.901804 74.901804 0 0 1 22.06012-2.052104zM691.341339 307.815631a41.042084 41.042084 0 0 1 40.529058 38.98998 40.529058 40.529058 0 0 1-26.677355 40.016032 61.563126 61.563126 0 0 1-21.034068 3.078157H260.912481a40.529058 40.529058 0 0 1-42.581162-43.607215 40.016032 40.016032 0 0 1 35.398797-38.476954 56.432866 56.432866 0 0 1 15.903808 0zM301.954565 82.084168v40.529058h348.34469V82.084168z" p-id="6451" />

  </svg>
);

export const ReportsSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1637643975183"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7308"
  >
    <path d="M968 992 56 992c-13.248 0-24-10.688-24-24 0-13.312 10.752-24 24-24l912 0c13.248 0 24 10.752 24 24C992 981.312 981.312 992 968 992z" p-id="7309" />
    <path d="M176 560 128 560c-26.496 0-48 21.504-48 48l0 240C80 874.56 101.504 896 128 896l48 0c26.496 0 48-21.504 48-48L224 608C224 581.504 202.496 560 176 560zM128 848 128 608l48 0 0 240L128 848z" p-id="7310" />
    <path d="M416 272 368 272C341.504 272 320 293.504 320 320l0 528C320 874.56 341.504 896 368 896L416 896c26.496 0 48-21.504 48-48L464 320C464 293.504 442.496 272 416 272zM368 848 368 320 416 320l0 528L368 848z" p-id="7311" />
    <path d="M656 368 608 368c-26.56 0-48 21.44-48 48l0 432C560 874.56 581.504 896 608 896l48 0c26.496 0 48-21.504 48-48L704 416C704 389.44 682.56 368 656 368zM608 848 608 416l48 0 0 432L608 848z" p-id="7312" />
    <path d="M896 32l-48 0c-26.496 0-48 21.504-48 48l0 768c0 26.496 21.504 48 48 48L896 896c26.496 0 48-21.504 48-48l0-768C944 53.504 922.56 32 896 32zM848 848l0-768L896 80l0 768L848 848z" p-id="7313" />

  </svg>
);

export const ExpandSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1637829166502"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1863"
  >
    <path d="M853.333333 213.333333a42.666667 42.666667 0 0 0-42.666666-42.666666h-213.333334a42.666667 42.666667 0 0 0 0 85.333333h109.653334l-139.946667 140.373333a42.666667 42.666667 0 0 0 0 60.586667 42.666667 42.666667 0 0 0 60.586667 0L768 316.586667V426.666667a42.666667 42.666667 0 0 0 42.666667 42.666666 42.666667 42.666667 0 0 0 42.666666-42.666666zM456.96 567.04a42.666667 42.666667 0 0 0-60.586667 0L256 706.986667V597.333333a42.666667 42.666667 0 0 0-42.666667-42.666666 42.666667 42.666667 0 0 0-42.666666 42.666666v213.333334a42.666667 42.666667 0 0 0 42.666666 42.666666h213.333334a42.666667 42.666667 0 0 0 0-85.333333H316.586667l140.373333-140.373333a42.666667 42.666667 0 0 0 0-60.586667z" p-id="1864" />

  </svg>
);

export const SendSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1637834144133"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1871"
  >
    <path d="M1008.00076 6.285714q18.857143 13.714286 15.428571 36.571429l-146.285714 877.714286q-2.857143 16.571429-18.285714 25.714285-8 4.571429-17.714286 4.571429-6.285714 0-13.714286-2.857143l-258.857142-105.714286-138.285715 168.571429q-10.285714 13.142857-28 13.142857-7.428571 0-12.571428-2.285714-10.857143-4-17.428572-13.428572T365.715046 987.428571v-199.428571l493.714285-605.142857-610.857142 528.571428-225.714286-92.571428q-21.142857-8-22.857143-31.428572-1.142857-22.857143 18.285714-33.714285L969.143617 5.142857q8.571429-5.142857 18.285714-5.142857 11.428571 0 20.571429 6.285714z" p-id="1872" />

  </svg>
);
export const RejectSvg = ({ width = 26, height = 26 }) => (
  <svg
    width={ width }
    height={ height }
    t="1639042916393"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2155"
  >
    <path d="M512 1024c-282.7712 0-512-229.2288-512-512S229.2288 0 512 0s512 229.2288 512 512-229.2288 512-512 512z m0-128c212.0768 0 384-171.9232 384-384s-171.9232-384-384-384-384 171.9232-384 384 171.9232 384 384 384z m129.8176-150.8736l90.5088-90.5088L487.3088 409.6 396.8 500.1088l245.0176 245.0176z m-185.6-185.6l90.5088-90.5088L365.7088 288 275.2 378.5088l181.0176 181.0176z" p-id="2156" />

  </svg>
);

export const ReturnSvg = ({ width = 46, height = 46 }) => (
  <svg
    width={ width }
    height={ height }
    t="1639043130485"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4920"
  >
    <path d="M773 546.4H482.9c-19.3 0-35-15.7-35-35s15.7-35 35-35H773c19.3 0 35 15.7 35 35s-15.7 35-35 35z" p-id="4921" />
    <path d="M507.7 638.1c-9 0-17.9-3.4-24.7-10.3l-84-84c-17.9-17.9-17.9-47 0-64.9l84-84c13.7-13.7 35.8-13.7 49.5 0 13.7 13.7 13.7 35.8 0 49.5l-67 67 67 67c13.7 13.7 13.7 35.8 0 49.5a35.31 35.31 0 0 1-24.8 10.2z" p-id="4922" />
    <path d="M747 611c-38.7 88.2-127 149.9-229.5 149.3C381 759.4 270 647.6 270.2 511.1 270.4 374 381.9 262.6 519 262.6c102.4 0 190.5 62.2 228.6 150.7 5.6 12.9 18.2 21.4 32.3 21.4 25.1 0 42.2-25.7 32.3-48.8-15.8-36.9-38.6-70.7-67.8-99.9-60.2-60.2-140.3-93.4-225.4-93.4-84.5 0-165.7 33.6-225.4 93.4-60.2 60.2-93.4 140.3-93.4 225.4 0 85.2 33.2 165.2 93.4 225.4 60.2 60.2 140.3 93.4 225.4 93.4s165.2-33.2 225.4-93.4c28.7-28.7 51.2-61.8 66.9-97.8 10.1-23.1-7.1-48.9-32.3-48.9-13.8 0-26.5 8.2-32 20.9z" p-id="4923" />

  </svg>
);

export const DownloadSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1639052313471"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7017"
  >
    <path d="M432 0h160c26.6 0 48 21.4 48 48v336h175.4c35.6 0 53.4 43 28.2 68.2L539.4 756.6c-15 15-39.6 15-54.6 0L180.2 452.2c-25.2-25.2-7.4-68.2 28.2-68.2H384V48c0-26.6 21.4-48 48-48z m592 752v224c0 26.6-21.4 48-48 48H48c-26.6 0-48-21.4-48-48V752c0-26.6 21.4-48 48-48h293.4l98 98c40.2 40.2 105 40.2 145.2 0l98-98H976c26.6 0 48 21.4 48 48z m-248 176c0-22-18-40-40-40s-40 18-40 40 18 40 40 40 40-18 40-40z m128 0c0-22-18-40-40-40s-40 18-40 40 18 40 40 40 40-18 40-40z" p-id="7018" />

  </svg>
);

export const ErrorSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1639237939437"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1891"
  >
    <path d="M512 85.333333C277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667S746.666667 85.333333 512 85.333333z m42.666667 640h-85.333334v-85.333333h85.333334v85.333333z m0-170.666666h-85.333334V298.666667h85.333334v256z" p-id="1892" fill="#d81e06" />
  </svg>
);

export const ProgressSvg = () => (
  <svg
    t="1639898714759"
    width="22"
    height="22"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1529"
  >
    <path d="M359.850667 726.016c22.058667-23.466667 105.045333-93.141333 106.112-94.037333a46.293333 46.293333 0 0 1 60.074666 0c1.066667 0.896 84.053333 70.570667 106.112 94.037333l0.725334 0.768a24.533333 24.533333 0 0 1-18.133334 41.216H377.258667a24.533333 24.533333 0 0 1-18.133334-41.216l0.725334-0.768z m249.386666-229.248a29.013333 29.013333 0 0 0-10.325333 21.76 29.013333 29.013333 0 0 0 10.325333 21.76c7.168 6.186667 15.402667 13.056 24.149334 20.352 28.288 23.552 63.488 52.864 91.562666 84.394667a28.757333 28.757333 0 0 1-2.432 40.704 29.098667 29.098667 0 0 1-40.96-2.432c-25.173333-28.330667-57.173333-54.954667-85.376-78.421334-8.96-7.466667-17.408-14.506667-25.002666-21.077333-19.2-16.64-30.250667-40.448-30.250667-65.28 0-24.874667 11.008-48.64 30.293333-65.28 7.253333-6.314667 15.36-13.098667 23.893334-20.224 46.933333-39.296 125.568-105.045333 125.568-152.448V235.861333a28.970667 28.970667 0 0 0-29.013334-28.842666H300.288a28.970667 28.970667 0 0 0-29.013333 28.842666v44.714667c0 47.402667 78.634667 113.152 125.610666 152.448 8.533333 7.125333 16.64 13.909333 23.893334 20.181333 19.242667 16.64 30.293333 40.448 30.293333 65.28 0 24.874667-11.050667 48.682667-30.293333 65.322667-7.253333 6.314667-15.36 13.056-23.893334 20.224-46.933333 39.253333-125.568 105.002667-125.568 152.448v44.714667c0 15.872 13.013333 28.842667 29.013334 28.842666h391.338666c16 0 29.013333-12.970667 29.013334-28.842666 0-15.957333 12.970667-28.842667 29.013333-28.842667 15.957333 0 28.970667 12.885333 28.970667 28.842667a86.869333 86.869333 0 0 1-86.997334 86.528H300.288A86.869333 86.869333 0 0 1 213.333333 801.194667V756.48c0-74.325333 84.48-144.981333 146.218667-196.608 8.362667-6.997333 16.298667-13.610667 23.210667-19.584a29.013333 29.013333 0 0 0 10.325333-21.76 29.013333 29.013333 0 0 0-10.325333-21.76c-6.912-5.973333-14.848-12.629333-23.210667-19.626667C297.856 425.514667 213.333333 354.858667 213.333333 280.576V235.861333C213.333333 188.16 252.330667 149.333333 300.288 149.333333h391.381333c47.957333 0 86.997333 38.826667 86.997334 86.528v44.714667c0 74.282667-84.522667 144.981333-146.261334 196.565333-8.362667 6.997333-16.256 13.653333-23.168 19.626667z m-81.92-80.298667c-17.194667 14.933333-42.538667 14.933333-59.733333 0-0.554667-0.426667-20.778667-17.749333-43.818667-38.016-18.048-15.914667-6.954667-45.952 16.981334-45.952h113.365333c23.936 0 35.072 30.037333 17.024 45.952-23.04 20.266667-43.306667 37.546667-43.818667 37.973334z" p-id="1530" />

  </svg>
);

export const ResolvedSvg = ({ width = 15, height = 15 }) => (
  <svg
    width={ width }
    height={ height }
    t="1639899126269"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3216"
  >
    <path d="M832 96 192 96C139.072 96 96 139.072 96 192l0 640c0 52.928 43.072 96 96 96l640 0c52.928 0 96-43.072 96-96L928 192C928 139.072 884.928 96 832 96zM727.232 438.432l-256.224 259.008c-0.064 0.064-0.192 0.096-0.256 0.192-0.096 0.064-0.096 0.192-0.192 0.256-2.048 1.984-4.576 3.2-6.944 4.544-1.184 0.672-2.144 1.696-3.392 2.176-3.84 1.536-7.904 2.336-11.968 2.336-4.096 0-8.224-0.8-12.096-2.4-1.28-0.544-2.304-1.632-3.52-2.304-2.368-1.344-4.832-2.528-6.88-4.544-0.064-0.064-0.096-0.192-0.16-0.256-0.064-0.096-0.192-0.096-0.256-0.192l-126.016-129.504c-12.32-12.672-12.032-32.928 0.64-45.248 12.672-12.288 32.896-12.064 45.248 0.64l103.264 106.112 233.28-235.808c12.416-12.576 32.704-12.672 45.248-0.256C739.52 405.632 739.648 425.888 727.232 438.432z" p-id="3217" />

  </svg>
);

export const UploadSvg = ({ width = 15, height = 15 }) => (
  <svg
    t="1639899761662"
    width={ width }
    height={ height }
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1253"
  >
    <path d="M768 841.142857q0-14.857143-10.857143-25.714286t-25.714286-10.857143-25.714286 10.857143-10.857143 25.714286 10.857143 25.714286 25.714286 10.857143 25.714286-10.857143 10.857143-25.714286zm146.285714 0q0-14.857143-10.857143-25.714286t-25.714286-10.857143-25.714286 10.857143-10.857143 25.714286 10.857143 25.714286 25.714286 10.857143 25.714286-10.857143 10.857143-25.714286zm73.142857-128l0 182.857143q0 22.857143-16 38.857143t-38.857143 16l-841.142857 0q-22.857143 0-38.857143-16t-16-38.857143l0-182.857143q0-22.857143 16-38.857143t38.857143-16l244 0q12 32 40.285714 52.571429t63.142857 20.571429l146.285714 0q34.857143 0 63.142857-20.571429t40.285714-52.571429l244 0q22.857143 0 38.857143 16t16 38.857143zm-185.714286-370.285714q-9.714286 22.857143-33.714286 22.857143l-146.285714 0 0 256q0 14.857143-10.857143 25.714286t-25.714286 10.857143l-146.285714 0q-14.857143 0-25.714286-10.857143t-10.857143-25.714286l0-256-146.285714 0q-24 0-33.714286-22.857143-9.714286-22.285714 8-39.428571l256-256q10.285714-10.857143 25.714286-10.857143t25.714286 10.857143l256 256q17.714286 17.142857 8 39.428571z" p-id="1254" />

  </svg>
);

export const OperationsSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1641704186875"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2672"
  >
    <path d="M22.26347 541.849664v-7.573933C22.26347 291.255743 199.275479 89.54812 431.393593 51.150572a89.051098 89.051098 0 1 1 7.68869 89.062574C252.602857 174.467982 111.303093 337.881337 111.303093 534.275731v6.73621h-0.103281q0.103281 1.537738 0.103281 3.109903a44.525549 44.525549 0 0 1-89.039623 0v-2.27218zM742.211762 101.94183c154.404965 82.395217 259.487555 245.097082 259.487555 432.333901a488.862987 488.862987 0 0 1-28.539959 165.123228 89.028147 89.028147 0 1 1-83.772296-30.169502 399.984024 399.984024 0 0 0 23.295584-134.953726c0-152.626238-85.275607-285.23893-210.773391-352.910879a44.525549 44.525549 0 1 1 40.302507-79.400071z m21.66604 852.159335l0.103281 0.172135a487.440006 487.440006 0 0 1-251.993951 69.726092c-157.813235 0-298.194946-74.59177-387.750974-190.56476q-2.972195 0.195086-6.001768 0.195086a88.982244 88.982244 0 1 1 80.065658-50.04534c73.444205 92.241331 186.640085 151.363915 313.687084 151.363916a398.813507 398.813507 0 0 0 204.46178-56.024158 44.525549 44.525549 0 1 1 47.440366 75.165554z" p-id="2673" />

  </svg>
);

export const PackagesSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1641704367287"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6711"
  >
    <path d="M704 443.733333c-8.533333 0-12.8 0-21.333333-4.266666L298.666667 217.6c-21.333333-12.8-25.6-38.4-17.066667-59.733333 12.8-21.333333 38.4-25.6 59.733333-17.066667l384 221.866667c21.333333 12.8 25.6 38.4 17.066667 59.733333-8.533333 12.8-25.6 21.333333-38.4 21.333333z" p-id="6712" />
    <path d="M512 981.333333c-21.333333 0-42.666667-4.266667-64-17.066666l-298.666667-170.666667C110.933333 772.266667 85.333333 729.6 85.333333 682.666667V341.333333c0-46.933333 25.6-89.6 64-110.933333l298.666667-170.666667c38.4-21.333333 89.6-21.333333 128 0l298.666667 170.666667c38.4 21.333333 64 64 64 110.933333v341.333334c0 46.933333-25.6 89.6-64 110.933333l-298.666667 170.666667c-21.333333 12.8-42.666667 17.066667-64 17.066666z m0-853.333333c-8.533333 0-12.8 0-21.333333 4.266667l-298.666667 170.666666c-12.8 8.533333-21.333333 21.333333-21.333333 38.4v341.333334c0 17.066667 8.533333 29.866667 21.333333 38.4l298.666667 170.666666c12.8 8.533333 29.866667 8.533333 42.666666 0l298.666667-170.666666c12.8-8.533333 21.333333-21.333333 21.333333-38.4V341.333333c0-17.066667-8.533333-29.866667-21.333333-38.4l-298.666667-170.666666c-8.533333-4.266667-12.8-4.266667-21.333333-4.266667z m384 554.666667z" p-id="6713" />
    <path d="M512 554.666667c-8.533333 0-12.8 0-21.333333-4.266667l-371.2-213.333333c-21.333333-17.066667-29.866667-42.666667-17.066667-59.733334 12.8-21.333333 38.4-29.866667 59.733333-17.066666l349.866667 204.8 349.866667-204.8c21.333333-12.8 46.933333-4.266667 59.733333 17.066666 12.8 21.333333 4.266667 46.933333-17.066667 59.733334l-371.2 213.333333c-8.533333 4.266667-12.8 4.266667-21.333333 4.266667z" p-id="6714" />
    <path d="M512 985.6c-25.6 0-42.666667-17.066667-42.666667-42.666667V512c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667v430.933333c0 21.333333-17.066667 42.666667-42.666667 42.666667z" p-id="6715" />

  </svg>
);

export const AnnouncementsSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    t="1641704700979"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="17060"
  >
    <path d="M850.944 157.915a64.073 64.073 0 0 0-59.465-7.46L360.448 320.878h-151.99a136.265 136.265 0 0 0-135.315 135.24v86.31A135.973 135.973 0 0 0 208.457 679.79h40.229v154.99c0.804 64.365 53.175 116.15 117.54 116.15h24.43a118.126 118.126 0 0 0 118.053-119.588v-83.968l279.917 109.275a51.127 51.127 0 0 0 26.112 4.9 63.195 63.195 0 0 0 34.158-10.678 60.416 60.416 0 0 0 28.745-52.297V211.675a62.39 62.39 0 0 0-26.697-53.76zM713.289 741.157V438.565a41.765 41.765 0 0 0-41.545-42.058 41.765 41.765 0 0 0-41.545 42.058v269.75l-140.142-55.15a47.25 47.25 0 0 0-60.928 26.844l-3.291 9.509v149.138a39.278 39.278 0 0 1-10.825 28.014 40.375 40.375 0 0 1-29.477 10.971h-21.797a37.669 37.669 0 0 1-37.449-37.815V651.118a55.735 55.735 0 0 0-55.369-56.028h-68.608a55.37 55.37 0 0 1-39.716-17.042 58.222 58.222 0 0 1-16.311-40.814v-89.453a56.613 56.613 0 0 1 55.661-55.15H352.55a58.222 58.222 0 0 0 21.504 0L804.57 219.429v557.494l-91.282-35.84z" p-id="17061" />

  </svg>
);

export const DocsSvg = ({ width = 18, height = 18, style, ...props }) => (
  <svg
    width={ width }
    height={ height }
    style={ style }
    t="1644083200283"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2826"
    { ...props }
  >
    <path d="M925.866667 669.866667 925.866667 669.866667l-298.666667 298.666667 0 0C620.8 977.066667 610.133333 981.333333 597.333333 981.333333L170.666667 981.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333L85.333333 128c0-46.933333 38.4-85.333333 85.333333-85.333333l682.666667 0c46.933333 0 85.333333 38.4 85.333333 85.333333l0 512C938.666667 652.8 934.4 663.466667 925.866667 669.866667zM640 836.266667l153.6-153.6L661.333333 682.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333L640 836.266667zM832 128 192 128C179.2 128 170.666667 136.533333 170.666667 149.333333l0 725.333333c0 12.8 8.533333 21.333333 21.333333 21.333333l362.666667 0L554.666667 682.666667c0-46.933333 38.4-85.333333 85.333333-85.333333l213.333333 0L853.333333 149.333333C853.333333 136.533333 844.8 128 832 128zM725.333333 469.333333 298.666667 469.333333c-23.466667 0-42.666667-19.2-42.666667-42.666667 0-23.466667 19.2-42.666667 42.666667-42.666667l426.666667 0c23.466667 0 42.666667 19.2 42.666667 42.666667C768 450.133333 748.8 469.333333 725.333333 469.333333zM725.333333 298.666667 298.666667 298.666667c-23.466667 0-42.666667-19.2-42.666667-42.666667s19.2-42.666667 42.666667-42.666667l426.666667 0c23.466667 0 42.666667 19.2 42.666667 42.666667S748.8 298.666667 725.333333 298.666667z" p-id="2827" />
  </svg>
);

export const DocsFlippedSvg = props => (
  <DocsSvg { ...props } style={{ transform: 'scaleY(-1)' }} />
);

export const ChatSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    className="bi bi-chat-left-text"
    viewBox="0 0 16 16"
  >
    <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
    <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
  </svg>
);

export const CalendarSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={ width }
    height={ height }
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 8H4v8h16v-8zm-5-6H9v2H7V5H4v4h16V5h-3v2h-2V5zm-9 8h2v2H6v-2zm5 0h2v2h-2v-2zm5 0h2v2h-2v-2z" />
    </g>
  </svg>
);


export const SupplySvg = ({ width = 36, height = 36 }) => (
  <svg
    t="1641704367291"
    className="icon"
    viewBox="0 0 256 256"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6711"
    width={ width }
    height={ height }
  >
    <path d="M216,68H171.81006a43.99152,43.99152,0,0,0-87.62012,0H40A12.01312,12.01312,0,0,0,28,80V208a12.01312,12.01312,0,0,0,12,12H216a12.01312,12.01312,0,0,0,12-12V80A12.01312,12.01312,0,0,0,216,68ZM128,36a36.04775,36.04775,0,0,1,35.77246,32H92.22754A36.04775,36.04775,0,0,1,128,36Zm92,172a4.004,4.004,0,0,1-4,4H40a4.004,4.004,0,0,1-4-4V80a4.004,4.004,0,0,1,4-4H84v28a4,4,0,0,0,8,0V76h72v28a4,4,0,0,0,8,0V76h44a4.004,4.004,0,0,1,4,4Z" />
  </svg>
);

export const LightbulbSvg = ({ width = 14, height = 14, fill = '#1890ff' }) => (
  <svg
    width={ width }
    height={ height }
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2ZM14 16H10V15.58C8.84 15.06 8 13.89 8 12.5H10C10 13.33 10.67 14 11.5 14H12.5C13.33 14 14 13.33 14 12.5H16C16 13.89 15.16 15.06 14 15.58V16ZM12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9C14 10.1 13.1 11 12 11ZM9 20V21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9Z"
      fill={ fill }
    />
  </svg>
);

export const ExclamationCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="currentColor"
    className="icon"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
  </svg>
);

export default {
  [icons.DRUGS]: DrugsIconSvg,
  [icons.HOME]: HomeIconSvg,
  [icons.MENU]: MenuIconSvg,
  [icons.MENU2]: MenuSvg,
  [icons.MENU_R_ARROW]: MenuRArrowSvg,
  [icons.MENU_L_ARROW]: MenuLArrowSvg,
  [icons.SHARE]: MenuShareSvg,
  [icons.PIE]: MenuReportsSvg,
  [icons.UNITS]: MenuUnitSvg,
  [icons.USERS]: MenuUsersSvg,
  [icons.HELP]: MenuHelpSvg,
  [icons.MAIL]: MenuMailSvg,
  [icons.RECAL]: MenuRecallSvg,
  [icons.BLOCK]: MenuBlockSvg,
  [icons.ERROR_MESSAGES]: MenuErrorMessagesSvg,
  [icons.PORTAL]: MenuPortalSvg,
  [icons.SETTINGS]: MenuSystemManagementSvg,
  [icons.DIRECTION]: MenuOfferDemandSvg,
  [icons.CHECK]: CheckSvg,
  [icons.CROSS]: CrossSvg,
  [icons.WHITE_CROSS]: WhiteCrossSvg,
  [icons.WHITE_CHECK]: WhiteCheckSvg,
  [icons.SEARCH]: SearchSvg,
  [icons.PLUS]: PlusSvg,
  [icons.MENU_D_ARROW]: MenuDArrowSvg,
  [icons.QUESTION]: QuestionSvg,
  [icons.LANGUAGE]: LanguagesSvg,
  [icons.LOGOUT]: LogoutSvg,
  [icons.STACK]: StackSvg,
  [icons.MONITOR]: MonitorSvg,
  [icons.LIGHT_CHECK]: LightCheckSvg,
  [icons.PASSWORD]: PasswordSvg,
  [icons.USER]: UserSvg,
  [icons.CSV]: CsvSvg,
  [icons.EDIT]: EditSvg,
  [icons.DUPLICATE]: DuplicateSvg,
  [icons.MAX]: Max,
  [icons.ESTABLISHMENT]: EstablishmentsSvg,
  [icons.MORE]: MoreSvg,
  [icons.SWITCH]: SwitchSvg,
  [icons.RESET_PASS]: ResetPasswordSvg,
  [icons.HISTORY]: HistorySvg,
  [icons.DEMAND_AND_OFFER]: DemandOfferSvg,
  [icons.REPORT]: ReportsSvg,
  [icons.EXPAND]: ExpandSvg,
  [icons.SEND]: SendSvg,
  [icons.REJECT]: RejectSvg,
  [icons.RETURN]: ReturnSvg,
  [icons.DOWNLOAD]: DownloadSvg,
  [icons.ERROR]: ErrorSvg,
  [icons.PROGRESS]: ProgressSvg,
  [icons.RESOLVE]: ResolvedSvg,
  [icons.UPLOAD]: UploadSvg,
  [icons.OPERATIONS]: OperationsSvg,
  [icons.PACKAGES]: PackagesSvg,
  [icons.ANNOUNCEMENTS]: AnnouncementsSvg,
  [icons.DOCS]: DocsSvg,
  [icons.DOCS_FLIPPED]: DocsFlippedSvg,
  [icons.Chat]: ChatSvg,
  [icons.Calendar]: CalendarSvg,
  [icons.Supply]: SupplySvg,
  [icons.ExclamationCircle]: ExclamationCircle,
  [icons.LIGHTBULB]: LightbulbSvg

};
